export default "__VITE_ASSET__B3xiNJ$H__"